(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hs-hero-type"] && !Shopify.designMode) return;
  try {
    
  /* No computador, a foto anda um pouco mais devagar que o texto ao rolar. */
  (() => {
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    const wide = window.matchMedia('(min-width: 990px)');
    const init = (root) => {
      if (root.dataset.hstReady || reduce.matches) return;
      root.dataset.hstReady = '1';
      const photo = root.querySelector('[data-hst-parallax]');
      if (!photo) return;
      let raf = 0;
      const update = () => {
        raf = 0;
        if (!wide.matches) { photo.style.translate = ''; return; }
        const r = root.getBoundingClientRect();
        if (r.bottom < 0 || r.top > window.innerHeight) return;
        photo.style.translate = `0 ${(Math.max(0, -r.top) * 0.1).toFixed(1)}px`;
      };
      window.addEventListener('scroll', () => { if (!raf) raf = requestAnimationFrame(update); }, { passive: true });
      window.addEventListener('resize', update);
      update();
    };
    const boot = () => document.querySelectorAll('.hst').forEach(init);
    boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-poster"] && !Shopify.designMode) return;
  try {
    
  /* As faixas andam sozinhas e aceleram quando a página rola; a foto sobe um pouco mais devagar.
     Com movimento reduzido nada se mexe e a seção fica como no desenho estático. */
  (() => {
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

    const init = (root) => {
      if (root.dataset.hspReady || reduce.matches) return;
      root.dataset.hspReady = '1';
      const tracksA = [...root.querySelectorAll('[data-hsp-track="a"]')];
      const tracksB = [...root.querySelectorAll('[data-hsp-track="b"]')];
      const photo = root.querySelector('[data-hsp-parallax]');
      // no celular a foto fica parada, centralizada nas faixas
      const phone = window.matchMedia('(max-width: 749px)');
      if (!tracksA.length) return;

      // cada faixa tem o mesmo texto duas vezes; ao andar meia faixa, volta ao início sem emenda
      let half = 0;
      const measure = () => { half = tracksA[0].scrollWidth / 2; };
      measure();
      if (document.fonts) document.fonts.ready.then(measure);
      window.addEventListener('resize', measure);

      let x = 0;
      let boost = 0;
      let lastY = window.scrollY;
      let visible = false;
      let raf = 0;

      const frame = () => {
        raf = 0;
        if (!visible || !half) return;
        const dy = Math.abs(window.scrollY - lastY);
        lastY = window.scrollY;
        boost = boost * 0.9 + Math.min(dy, 80) * 0.12;
        x = (x + 0.5 + boost) % half;
        const a = `translate3d(${-x}px, 0, 0)`;
        const b = `translate3d(${x - half}px, 0, 0)`;
        tracksA.forEach((t) => { t.style.transform = a; });
        tracksB.forEach((t) => { t.style.transform = b; });
        if (photo && phone.matches) {
          photo.style.transform = '';
        } else if (photo) {
          const r = root.getBoundingClientRect();
          const p = (r.top + r.height / 2 - window.innerHeight / 2) / window.innerHeight;
          photo.style.transform = `translate3d(0, ${(Math.max(-1, Math.min(1, p)) * -56).toFixed(1)}px, 0)`;
        }
        raf = requestAnimationFrame(frame);
      };

      new IntersectionObserver(([entry]) => {
        visible = entry.isIntersecting;
        if (visible && !raf) {
          lastY = window.scrollY;
          raf = requestAnimationFrame(frame);
        }
      }).observe(root);
    };

    const boot = () => document.querySelectorAll('.hsp').forEach(init);
    boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
